import { Funder } from "@/types/FunderTypes";
import { ReactNode, createContext, useContext, useState } from "react";

interface SelectedFunderContextType {
  selectedFunder: Funder | null;
  setSelectedFunder: React.Dispatch<React.SetStateAction<Funder | null>>;
  resetSelectedFunder: () => void;
  currentFunderListUpdatedTime: Date | null;
  setCurrentFunderListUpdatedTime: React.Dispatch<React.SetStateAction<Date | null>>;
}

const SelectedFunderContext = createContext<SelectedFunderContextType | undefined>(undefined);

interface SelectedFunderProviderProps {
  children: ReactNode;
}

export const FundraisingProvider: React.FC<SelectedFunderProviderProps> = ({ children }) => {
  const [currentFunderListUpdatedTime, setCurrentFunderListUpdatedTime] = useState<Date | null>(null);

  const [selectedFunder, setSelectedFunder] = useState<Funder | null>(null);

  const resetSelectedFunder = () => {
    setSelectedFunder(null);
  };

  const contextValue: SelectedFunderContextType = {
    selectedFunder,
    setSelectedFunder,
    resetSelectedFunder,
    currentFunderListUpdatedTime,
    setCurrentFunderListUpdatedTime,
  };

  return <SelectedFunderContext.Provider value={contextValue}>{children}</SelectedFunderContext.Provider>;
};

export const useFundraising = (): SelectedFunderContextType => {
  const context = useContext(SelectedFunderContext);

  if (!context) {
    return {
      setCurrentFunderListUpdatedTime: () => null,
      currentFunderListUpdatedTime: null,
      selectedFunder: null,
      setSelectedFunder: () => null,
      resetSelectedFunder: () => null,
    };
  }

  return context!;
};
